import {
  TlsProfileState,
  TlsProfileActionTypes,
  GET_TLS_PROFILE_LIST,
  GET_TLS_PROFILE_LIST_FULFILLED,
  GET_TLS_PROFILE_PENDING,
  GET_TLS_PROFILE_FULFILLED,
  SELECT_TLS_PROFILE,
  CREATE_TLS_PROFILE_PENDING,
  CREATE_TLS_PROFILE_FULFILLED,
  DELETE_TLS_PROFILE_FULFILLED,
  SET_TLS_PROFILE_LOADING,
} from './tlsProfile.types';

export const initialState: TlsProfileState = {
  entities: [],
  selected: [],
  single: null,
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isLoading: false,
  },
};

export default function tlsProfileReducer(
  state = initialState,
  action: TlsProfileActionTypes,
): TlsProfileState {
  switch (action.type) {
    case GET_TLS_PROFILE_LIST:
      return {
        ...state,
        selected: [],
      };

    case GET_TLS_PROFILE_LIST_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data ?? [],
        selected: [],
      };

      case GET_TLS_PROFILE_PENDING:
      return {
        ...state,
        single: null,
      };

    case GET_TLS_PROFILE_FULFILLED:
      return {
        ...state,
        single: (action.payload.data.data ?? [])[0],
      };

    case SELECT_TLS_PROFILE:
      return {
        ...state,
        selected: action.payload || [],
      };

    case CREATE_TLS_PROFILE_PENDING:
      return {
        ...state,
        createdId: null,
      };

    case CREATE_TLS_PROFILE_FULFILLED:
      return {
        ...state,
        createdId: action.payload.data.metadata?.idCreated ?? null,
      };

    case DELETE_TLS_PROFILE_FULFILLED:
      return {
        ...state,
        selected: [],
      };

    case SET_TLS_PROFILE_LOADING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

    default:
      return state;
  }
}
